<template>
  <div class="SectionPeriodSearchPanel">
    <div>
      <box :title="this.$t('search')" class="card">
        <div class="px-3 pt-2">
          <table>
            <tbody>
              <tr>
                <td>
                  <label>{{ $t("year") }} : </label>
                </td>
                <td>
                  <v-select
                    hide-details=""
                    v-model="year"
                    :items="years"
                    :label="$t('year')"
                    item-text="Name"
                    item-value="Name"
                    return-object
                    dense
                    solo
                    v-on:change="changeYear"
                    class="my-auto pa-0"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>
                  <label>{{ $t("period") }} : </label>
                </td>
                <td>
                  <v-select
                    hide-details=""
                    v-model="month"
                    :items="months"
                    :label="$t('period')"
                    dense
                    solo
                    class="my-auto pa-0"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>
                  <label>{{ $t("sectionType") }} : </label>
                </td>
                <td>
                  <v-select
                    hide-details
                    v-model="sectionType"
                    :items="sectionTypes"
                    :label="$t('sectionType')"
                    item-text="Name"
                    item-value="Code"
                    return-object
                    dense
                    solo
                    v-on:change="changeSectionType"
                    class="my-auto py-0"
                  ></v-select>
                </td>
              </tr>
            </tbody>
          </table>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="search">{{ $t("search") }}</v-btn>
          </v-card-actions>
        </div>
      </box>
    </div>
  </div>
</template>

<script>
import EosToastType from "../../model/EosToastType";
import ResultType from "../../model/ResultType";
import EosUtils from "../../utils/EosUtils";
export default {
  data() {
    return {
      year: {},
      month: "",
      years: [],
      months: [],
      sectionType: "",
      sectionTypes: [],
    };
  },
  mounted() {
    this.getYears();
    this.loadSectionList();
  },
  methods: {
    getYears() {
      this.$store
        .dispatch("GetEosPeriodicYearsList")
        .then((result) => {
          if (result.type === "success") {
            var data = [];
            data = result.data;
            this.years = data;
            this.year = data.slice(-1)[0];
            this.getPeriods();
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });
          }
        })
        .catch((error) => {
          //console.log(error);
          this.$EosToast.show({
            type: EosToastType.error,
            msg: `${error}`,
          });
        });
      return [];
    },
    changeYear() {
      //this.year = e.Name
      this.getPeriods();
    },
    getPeriods() {
      if (this.year == {}) {
        return;
      }

      const params = new URLSearchParams();
      params.append("year", this.year.Name);

      this.$store
        .dispatch("GetEosPeriodList", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            var data = [];
            data = result.data;
            //if (data.length > 0) {
            this.months = data;
            // this.month = data.slice(-1)[0];
             this.month = this.months[0];

            this.search();
            //}
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });
          }
        })
        .catch((error) => {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: `${error}`,
          });
        });
      return [];
    },
    async loadSectionList() {
      this.sectionTypes = [];
      if (EosUtils.isWebKartAdmin()) {
        this.getAllSection();
      } else {
        this.getSectionWithPermissionNumber();
      }
    },
    getAllSection() {
      this.sectionTypes.push({ Name: this.$t("allSection"), Code: "0" });

      this.$store.dispatch("sections/GetAllSections").then((result) => {
        ////console.log(result);
        if (result.type == ResultType.success) {
          this.sectionTypes.push(...result.data);
          if (this.sectionTypes.length > 0) {
            this.sectionType = this.sectionTypes[0];
          }

          this.search();
        } else {
          this.sectionTypes.splice(0);
        }
      });
    },
    async getSectionWithPermissionNumber() {
      var params = new URLSearchParams();
      params.append("accessTo", 16);

      //

      this.$store
        .dispatch("sections/GetSectionsList", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type == ResultType.success) {
            if (result.data && result.data.length > 0) {
              if (result.data[0].Code == "-1") {
                this.sectionTypes.push({
                  Name: this.$t("allSection"),
                  Code: "-1",
                });

                this.$store
                  .dispatch("sections/GetAllSections")
                  .then((result) => {
                    ////console.log(result);
                    if (result.type == ResultType.success) {
                      this.sectionTypes.push(...result.data);
                      if (this.sectionTypes.length > 0) {
                        this.sectionType = this.sectionTypes[0];
                      }
                    }
                  });
              } else {
                this.sectionTypes.push(...result.data);

                if (this.sectionTypes.length > 0) {
                  this.sectionType = this.sectionTypes[0];
                }
              }
            }

            this.search();
          }
        });
    },

    changeSectionType() {
      this.search();
    },
    search() {
      var searchParams = {
        sectioncode: this.sectionType?.Code?.toString().trim() || "-1",
        year: this.year.Name,
        month: this.month,
      };

      this.$emit("search", searchParams);
    },
  },
};
</script>

<style>
</style>